module.exports = __webpack_public_path__ + "static/media/checkbox_unchecked.ca1e7672.svg";